import { makeStyles } from '@material-ui/core';
import TwinSpin from "react-cssfx-loading/lib/TwinSpin";
import FlagstoneTheme from '../../../config/flagstoneTheme';

export default function UpdatingSQLComponent(props) {

    const classes = useStyles();    

    return (

        <div className={classes.container}>           
           <TwinSpin color={FlagstoneTheme.palette.primary.main} width="100px" height="100px" duration="3s" />
           <div className={classes.text}>Executing scripts...</div>
        </div>
    )
}

const useStyles = makeStyles({ 
    container:{
        display:"flex",
        width: "100%",
        flexDirection:"column",
        justifyContent:"center",
        height:"700px",
        alignItems:"center"
    },
    text:{
        color: FlagstoneTheme.palette.primary.main,
        marginTop: "30px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        fontSize: "18px",
    }

});